<template>
  <node-view-wrapper
    class="repeat-section-wrapper"
    :class="{
      'repeat-section--template': isTemplateMode,
      'repeat-section--expanded': !isTemplateMode,
    }"
  >
    <div class="repeat-section-header" contenteditable="false">
      <div class="repeat-section-header__left">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="repeat-section-icon"
          style="width: 14px; height: 14px"
        >
          <polyline points="17 1 21 5 17 9" />
          <path d="M3 11V9a4 4 0 0 1 4-4h14" />
          <polyline points="7 23 3 19 7 15" />
          <path d="M21 13v2a4 4 0 0 1-4 4H3" />
        </svg>
        <span class="repeat-section-label">
          {{ headerLabel }}
        </span>
      </div>
      <div v-if="canUnwrap || canDelete" class="repeat-section-header__right">
        <!-- Конструктор: убрать обёртку секции -->
        <button
          v-if="canUnwrap"
          class="repeat-section-delete-btn"
          :title="$t('Убрать секцию')"
          :aria-label="$t('Убрать секцию')"
          @click="unwrapSection"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        <!-- НД: удалить секцию участника -->
        <button
          v-if="canDelete"
          class="repeat-section-delete-btn"
          :title="$t('Удалить секцию')"
          aria-label="Удалить секцию"
          @click="deleteNode"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="3 6 5 6 21 6" />
            <path
              d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
            />
          </svg>
        </button>
      </div>
    </div>
    <node-view-content class="repeat-section-content" />
  </node-view-wrapper>
</template>

<script>
import { NodeViewWrapper, NodeViewContent } from "@tiptap/vue-3";

export default {
  name: "RepeatSectionView",
  components: {
    NodeViewWrapper,
    NodeViewContent,
  },
  props: {
    node: { type: Object, required: true },
    editor: { type: Object, required: true },
    extension: { type: Object, required: true },
    getPos: { type: Function, required: true },
    deleteNode: { type: Function, required: true },
  },
  computed: {
    isTemplateMode() {
      return this.extension.options.mode === "edit";
    },
    isEditMode() {
      return this.editor.isEditable;
    },
    canUnwrap() {
      return (
        this.isEditMode &&
        this.extension.options.allowUnwrap !== false &&
        !!this.node.attrs.placeholderCode
      );
    },
    canDelete() {
      // Копия секции (без placeholder) в НД — можно удалить
      return (
        this.isEditMode &&
        this.extension.options.allowUnwrap === false &&
        !this.node.attrs.placeholderCode
      );
    },
    headerLabel() {
      const label = this.node.attrs.label || this.node.attrs.placeholderCode;
      if (this.node.attrs.placeholderCode) {
        return `${this.$t("Повторяемая секция")}: ${label}`;
      }
      return label;
    },
  },
  methods: {
    unwrapSection() {
      const pos = this.getPos();
      if (typeof pos !== "number") return;

      const node = this.node;
      const { tr } = this.editor.state;

      // Заменяем repeatSection на его содержимое
      if (node.content && node.content.size > 0) {
        tr.replaceWith(pos, pos + node.nodeSize, node.content);
        this.editor.view.dispatch(tr);
      }
    },
  },
};
</script>

<style scoped>
.repeat-section-wrapper {
  @apply relative my-3 rounded-lg;
}
.repeat-section--template {
  @apply border  border-border;
  background: #fff;
}
.repeat-section--expanded {
  @apply border border-border bg-muted;
}
.repeat-section-header {
  @apply flex items-center justify-between px-3 py-1.5 rounded-t-lg select-none border-b border-border;
}
.repeat-section--template .repeat-section-header {
  @apply bg-accent text-accent-foreground;
}
.repeat-section--expanded .repeat-section-header {
  @apply bg-muted text-muted-foreground;
}
.repeat-section-header__left {
  @apply flex items-center gap-2 text-sm font-medium h-6;
}
.repeat-section-header__right {
  @apply flex items-center gap-1;
}
.repeat-section-icon {
  @apply w-4 h-4 flex-shrink-0 opacity-70 text-foreground;
}
.repeat-section-label {
  @apply truncate text-xs text-foreground;
}
.repeat-section-delete-btn {
  @apply p-1 rounded hover:bg-accent text-muted-foreground hover:text-foreground
    transition-colors cursor-pointer;
}
.repeat-section-content {
  @apply px-3 py-2 rounded-b-lg;
  background: #fff;
}
</style>
